var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey__counter"},[_c('strong',[_vm._v(_vm._s(_vm._f("paddy")(_vm.number,2)))]),_vm._v(_vm._s(' ')+" / "+_vm._s(_vm._f("paddy")(_vm.total,2)))])
}
var staticRenderFns = []

export { render, staticRenderFns }